module.exports = __webpack_public_path__ + "static/media/easilycompareattendanceawithworkschedules.f602dd1a.webp";